export const styles = theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    toolbar: {
      backgroundColor: "#424242",
      paddingRight: "5px",
      paddingLeft: "5px",
      display: "flex",
      justifyContent: "space-between"
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
    },
    smallAvatar: {
      width: "35px",
      height: "35px"
    },
    alertTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignContent: "center",
      alignItems: "center",
      padding: "10px"
    },
    alertText: {
      display: "flex",
      "flex-direction": "column"
    },
    thresholdContainer: {
      display: "flex",
      justifyContent: "center",
      flexWrap: "no-wrap"
    },
    badge: {
      width: "18px",
      height: "18px",
      fontSize: 11,
      fontWeight: 500,
      left: -11
    }

  });


// WEBPACK FOOTER //
// ./src/styles/drawer-list-styles.js